import { observable, action } from 'mobx';

import { CommonApi, UsersApi } from '../constants/RolesApi';

export default class ApiStore {
    @observable.ref api: CommonApi = {};

    @action setApiByRole = () => {
        this.api = {
            ...this.api,
            ...UsersApi
        };
    };
}

export const apiStore = new ApiStore();
